import * as Yup from "yup";
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import api from "../../../service/api";
import { Card, Col, Form, Button, Row } from "react-bootstrap";
import DatePicker from "react-datepicker";
import { TimePicker } from "antd";
import { Plus, Trash } from "react-feather";
import moment from "moment";
import Select from "react-select";
import { addDefaultOption } from "../../../utils/utility";
import { UserDateFormat } from "../../../utils/dateFormat";
import { Formik } from "formik";
import { SnackbarAlert } from "../../../components/SnackbarAlert";
import { Helmet } from "react-helmet-async";


const AdhocTpmrTrainingDates = () => {
    /** Get path from summary page  */
    const { state } = useLocation();
    let redirectPath = "/tms/batches/pending";
    if (state?.path) {
        redirectPath = `/tms/batches/${state?.path}`;
    }
    let { id } = useParams();
    const DateFormat = UserDateFormat();
    const format = "HH:mm";
    const navigate = useNavigate();

    const [batch, setBatch] = useState(null);
    const [loading, setLoading] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [trainerList, setTrainerList] = useState();
    const [initValues, setInitialValues] = useState({training_dates: []});
    const [notif, setNotif] = useState({
        notifMsg: "",
        open: false,
        severity: "success",
    });

    const schema = Yup.object().shape({
        training_dates: Yup.array().of(
            Yup.object().shape({
                date: Yup.string().required(),
                training_type: Yup.string().required(),
            })
        ),
    });

    const handleFormSelectChangeItems = (event, name, index) => {
        let data = [...initValues.training_dates];
        data[index][name] = event?.value;

        setInitialValues({
            ...initValues,
            training_dates: data,
        });
    };

    const handleDateSelection = (index, name, value) => {
        if (!value) return;

        let data = [...initValues.training_dates];
        data[index][name] = value;
        setInitialValues({
            ...initValues,
            training_dates: data,
        });
    };

    const deleteTrainingDate = (index) => {
        let updateInitialValues = { ...initValues };
        const { training_dates } = updateInitialValues;
        training_dates.splice(index, 1);
        setInitialValues({
            ...updateInitialValues,
            training_dates: training_dates,
        });
    };

    const handleFormChangeTrainingDates = (index, parent, child, event) => {
        let data = [...initValues.training_dates];
        data[index][parent][child] = event;

        setInitialValues({
            ...initValues,
            training_dates: data,
        });
    };

    const getBatch = async () => {
        const response = await api.get(`tms/batches/${id}`);
        const trainingDates = await api.get(`tms/batches/${id}/get-adhoc-training-dates`);
        const trainerResponse = await api.get(`tms/courses/trainers`);

        if (response.status === 'ok') // Yes I know this is trash but legacy code from BE
            setBatch(response.data);

        if (trainingDates.status === 'ok')
            setInitialValues({
                training_dates: trainingDates?.data?.length ? trainingDates?.data : [],
            });

        if (trainerResponse.status === 'ok')
            setTrainerList(trainerResponse.data);

    }

    const addTrainingDate = (e) => {
        let updateInitialValues = { ...initValues };
        const { training_dates } = updateInitialValues;
        training_dates.push({
            date: "",
            am: {
                from: "",
                to: "",
            },
            pm: {
                from: "",
                to: "",
            },
            ev: {
                from: "",
                to: "",
            },
            // session: [],
            trainer_id: "",
            training_type: "",
        });
        setInitialValues({ ...initValues, training_dates: training_dates });
    };

    const updateCreate = async (values) => {
        setIsSubmitting(true);
        try {
            const response = await api.post(`tms/batches/${id}/save-adhoc-training-dates`, values);
            if (response.success) {
                setNotif({
                    notifMsg: response.message,
                    open: true,
                    severity: "success",
                });
            } else {
                setNotif({
                    notifMsg: response.message,
                    open: true,
                    severity: "danger",
                });
            }
        } catch {
            setNotif({
                notifMsg: "Something went wrong with the server",
                open: true,
                severity: "danger",
            });
        }
        setIsSubmitting(false);
    };

    useEffect(() => {
        setLoading(true);
        getBatch();
        setLoading(false);
    }, []);

    return (
        <React.Fragment>
            <Helmet name="Adhoc Training Dates" />
            {!loading && <>
                <Formik
                    enableReinitialize
                    initialValues={initValues}
                    validationSchema={schema}
                    onSubmit={async (
                        values,
                        { setErrors, setStatus, setSubmitting }
                    ) => {
                        try {
                            setIsSubmitting(true);
                            await updateCreate(values);
                        } catch (error) {
                            const message =
                                error?.response?.data?.message;

                            setStatus({ success: false });
                            setErrors({ submit: message });
                            setNotif({
                                notifMsg: message,
                                open: true,
                                severity: "danger",
                            });
                        }
                        setSubmitting(false);
                        setIsSubmitting(false);
                    }}
                    validate={(values) => {
                        // This runs on every change and blur
                        try {
                            schema.validateSync(values, { abortEarly: false });
                        } catch (error) {
                            // Create comma-delimited string of all validation errors
                            const errorMessages = error.inner.map(err =>
                                `${err.path}: ${err.message}`
                            ).join(', ');

                            setNotif({
                                notifMsg: errorMessages,
                                open: true,
                                severity: "danger",
                            });
                        }
                    }}
                >
                    {({
                        errors,
                        handleSubmit,
                        values,
                        setFieldValue,
                    }) => (
                        <>
                            <Form onSubmit={handleSubmit}>
                                <h2>Adhoc Training Dates for {batch?.name ?? ''}</h2>
                                {initValues.training_dates?.map(
                                    (trainingData, i) => {
                                        return (
                                            <div key={`training-${i}`}>
                                                <hr />
                                                <Row>
                                                    <Col md={4}>
                                                        <Form.Group className="mb-3">
                                                            <Form.Label>
                                                                Training
                                                                Date {DateFormat}
                                                            </Form.Label>
                                                            <DatePicker
                                                                name="date"
                                                                selected={
                                                                    trainingData?.date !==
                                                                    "" &&
                                                                    new Date(
                                                                        moment(
                                                                            trainingData?.date,
                                                                            DateFormat.toUpperCase()
                                                                        ).format(
                                                                            "YYYY-MM-DD"
                                                                        )
                                                                    )
                                                                }
                                                                className={` form-control `}
                                                                size="lg"
                                                                onChange={(
                                                                    dates
                                                                ) => {
                                                                    handleDateSelection(
                                                                        i,
                                                                        `date`,
                                                                        dates
                                                                    );
                                                                    setFieldValue(
                                                                        `training_dates.[${i}].date`,
                                                                        values
                                                                            .training_dates[
                                                                            i
                                                                        ]
                                                                            ?.date
                                                                    );
                                                                }}
                                                                dateFormat={
                                                                    DateFormat
                                                                }
                                                                placeholderText={DateFormat.toUpperCase()}
                                                            />
                                                            {errors?.training_dates &&
                                                                errors
                                                                    .training_dates[
                                                                    i
                                                                ]?.date && (
                                                                    <Form.Control.Feedback type="invalid">
                                                                        Training
                                                                        date
                                                                        is
                                                                        required
                                                                    </Form.Control.Feedback>
                                                                )}{" "}
                                                        </Form.Group>
                                                    </Col>
                                                    <Col md={2}>
                                                        <Form.Group className="mb-3">
                                                            <Form.Label>
                                                                Training
                                                                Time (AM){" "}
                                                            </Form.Label>
                                                            <br />
                                                            <TimePicker
                                                                name={`training_dates.[${i}].am.from`}
                                                                className="form-control"
                                                                defaultValue={
                                                                    trainingData
                                                                        ?.am
                                                                        ?.from &&
                                                                    moment(
                                                                        trainingData
                                                                            ?.am
                                                                            ?.from,
                                                                        format
                                                                    )
                                                                }
                                                                onChange={(
                                                                    time,
                                                                    timeString
                                                                ) => {
                                                                    handleFormChangeTrainingDates(
                                                                        i,
                                                                        "am",
                                                                        "from",
                                                                        timeString
                                                                    );
                                                                }}
                                                                format={
                                                                    format
                                                                }
                                                            />
                                                        </Form.Group>
                                                    </Col>
                                                    <Col md={2}>
                                                        <Form.Group className="mb-3">
                                                            <Form.Label></Form.Label>
                                                            <br />
                                                            <TimePicker
                                                                name={`training_dates.[${i}].am.to`}
                                                                className="form-control mt-2"
                                                                defaultValue={
                                                                    trainingData
                                                                        ?.am
                                                                        ?.to &&
                                                                    moment(
                                                                        trainingData
                                                                            ?.am
                                                                            ?.to,
                                                                        format
                                                                    )
                                                                }
                                                                onChange={(
                                                                    time,
                                                                    timeString
                                                                ) => {
                                                                    handleFormChangeTrainingDates(
                                                                        i,
                                                                        "am",
                                                                        "to",
                                                                        timeString
                                                                    );
                                                                }}
                                                                format={
                                                                    format
                                                                }
                                                            />
                                                        </Form.Group>
                                                    </Col>
                                                    <Col md={2}>
                                                        <Form.Group className="mb-3">
                                                            <Form.Label>
                                                                Training
                                                                Time (PM){" "}
                                                            </Form.Label>
                                                            <br />
                                                            <TimePicker
                                                                name={`training_dates.[${i}].pm.from`}
                                                                className="form-control"
                                                                defaultValue={
                                                                    trainingData
                                                                        ?.pm
                                                                        ?.from &&
                                                                    moment(
                                                                        trainingData
                                                                            ?.pm
                                                                            ?.from,
                                                                        format
                                                                    )
                                                                }
                                                                onChange={(
                                                                    time,
                                                                    timeString
                                                                ) => {
                                                                    handleFormChangeTrainingDates(
                                                                        i,
                                                                        "pm",
                                                                        "from",
                                                                        timeString
                                                                    );
                                                                }}
                                                                format={
                                                                    format
                                                                }
                                                            />
                                                        </Form.Group>
                                                    </Col>
                                                    <Col md={2}>
                                                        <Form.Group className="mb-3">
                                                            <Form.Label></Form.Label>
                                                            <br />
                                                            <TimePicker
                                                                name={`training_dates.[${i}].pm.to`}
                                                                className="form-control mt-2"
                                                                defaultValue={
                                                                    trainingData
                                                                        ?.pm
                                                                        ?.to &&
                                                                    moment(
                                                                        trainingData
                                                                            ?.pm
                                                                            ?.to,
                                                                        format
                                                                    )
                                                                }
                                                                onChange={(
                                                                    time,
                                                                    timeString
                                                                ) => {
                                                                    handleFormChangeTrainingDates(
                                                                        i,
                                                                        "pm",
                                                                        "to",
                                                                        timeString
                                                                    );
                                                                }}
                                                                format={
                                                                    format
                                                                }
                                                            />
                                                        </Form.Group>
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <Col md={2}>
                                                        <Form.Group className="mb-3">
                                                            <Form.Label>
                                                                Training
                                                                Time (EV){" "}
                                                            </Form.Label>
                                                            <br />
                                                            <TimePicker
                                                                name={`training_dates.[${i}].ev.from`}
                                                                className="form-control"
                                                                defaultValue={
                                                                    trainingData
                                                                        ?.ev
                                                                        ?.from &&
                                                                    moment(
                                                                        trainingData
                                                                            ?.ev
                                                                            ?.from,
                                                                        format
                                                                    )
                                                                }
                                                                onChange={(
                                                                    time,
                                                                    timeString
                                                                ) => {
                                                                    handleFormChangeTrainingDates(
                                                                        i,
                                                                        "ev",
                                                                        "from",
                                                                        timeString
                                                                    );
                                                                }}
                                                                format={
                                                                    format
                                                                }
                                                            />
                                                        </Form.Group>
                                                    </Col>
                                                    <Col md={2}>
                                                        <Form.Group className="mb-3">
                                                            <Form.Label></Form.Label>
                                                            <br />
                                                            <TimePicker
                                                                name={`training_dates.[${i}].ev.to`}
                                                                className="form-control mt-2"
                                                                defaultValue={
                                                                    trainingData
                                                                        ?.ev
                                                                        ?.to &&
                                                                    moment(
                                                                        trainingData
                                                                            ?.ev
                                                                            ?.to,
                                                                        format
                                                                    )
                                                                }
                                                                onChange={(
                                                                    time,
                                                                    timeString
                                                                ) => {
                                                                    handleFormChangeTrainingDates(
                                                                        i,
                                                                        "ev",
                                                                        "to",
                                                                        timeString
                                                                    );
                                                                }}
                                                                format={
                                                                    format
                                                                }
                                                            />
                                                        </Form.Group>
                                                    </Col>
                                                    <Col md={4}>
                                                        <Form.Group className="mb-3">
                                                            <Form.Label>
                                                                Trainer
                                                            </Form.Label>
                                                            <Select
                                                                className="is-invalid react-select-container"
                                                                classNamePrefix="react-select "
                                                                options={addDefaultOption(
                                                                    trainerList?.map(
                                                                        (
                                                                            trainer,
                                                                            index
                                                                        ) => {
                                                                            return {
                                                                                label: trainer?.full_name,
                                                                                value: trainer?.id,
                                                                            };
                                                                        }
                                                                    )
                                                                )}
                                                                name="trainer_id"
                                                                isSearchable={
                                                                    true
                                                                }
                                                                isClearable={
                                                                    true
                                                                }
                                                                onChange={(
                                                                    option
                                                                ) =>
                                                                    handleFormSelectChangeItems(
                                                                        option,
                                                                        "trainer_id",
                                                                        i
                                                                    )
                                                                }
                                                                value={trainerList
                                                                    ?.filter(
                                                                        (
                                                                            trainer,
                                                                            index
                                                                        ) => {
                                                                            return (
                                                                                trainingData?.trainer_id ===
                                                                                trainer.id
                                                                            );
                                                                        }
                                                                    )
                                                                    .map(
                                                                        (
                                                                            mapTrainer
                                                                        ) => {
                                                                            return {
                                                                                label: mapTrainer.full_name,
                                                                                value: mapTrainer.id,
                                                                            };
                                                                        }
                                                                    )}
                                                            />
                                                        </Form.Group>
                                                    </Col>
                                                    <Col md={3}>
                                                        <Form.Group className="mb-3">
                                                            <Form.Label>
                                                                Training
                                                                type
                                                            </Form.Label>
                                                            <Select
                                                                className="is-invalid react-select-container"
                                                                classNamePrefix="react-select "
                                                                options={addDefaultOption(
                                                                    [
                                                                        // {
                                                                        //     value: "theory",
                                                                        //     label: "THEORY",
                                                                        // },
                                                                        // {
                                                                        //     value: "optional-theory",
                                                                        //     label: "OPTIONAL THEORY",
                                                                        // },
                                                                        {
                                                                            value: "practical",
                                                                            label: "PRACTICAL",
                                                                        },
                                                                        // {
                                                                        //     value: "optional-practical",
                                                                        //     label: "OPTIONAL PRACTICAL",
                                                                        // },
                                                                        // {
                                                                        //     value: "pre-registration",
                                                                        //     label: "PRE-REGISTRATION",
                                                                        // },
                                                                    ]
                                                                )}
                                                                selected="practical"
                                                                name="training_type"
                                                                isSearchable={
                                                                    true
                                                                }
                                                                isClearable={
                                                                    true
                                                                }
                                                                onChange={(
                                                                    option
                                                                ) =>
                                                                    handleFormSelectChangeItems(
                                                                        option,
                                                                        "training_type",
                                                                        i
                                                                    )
                                                                }
                                                                defaultValue={[
                                                                    {
                                                                        value: trainingData?.training_type,
                                                                        label: trainingData?.training_type?.toUpperCase(),
                                                                    },
                                                                ]}
                                                            />
                                                        </Form.Group>
                                                    </Col>
                                                    <Col md={1}>
                                                        {!isSubmitting
                                                            &&
                                                            <Button
                                                                variant="danger"
                                                                className="mt-4"
                                                                onClick={() =>
                                                                    deleteTrainingDate(
                                                                        i
                                                                    )
                                                                }
                                                            >
                                                                <Trash
                                                                    size={15}
                                                                    className="m-0"
                                                                ></Trash>
                                                            </Button>
                                                        }
                                                    </Col>
                                                </Row>
                                            </div>
                                        );
                                    }
                                )}
                                {!isSubmitting &&
                                    <Button
                                        variant="success"
                                        className="mb-4"
                                        type="button"
                                        onClick={addTrainingDate}
                                    >
                                        <Plus size={15} className="m-0"></Plus>
                                    </Button>
                                }
                                <hr />
                                <div className="d-flex flex-row align-items-center p-2 justify-content-end">
                                    {!isSubmitting &&
                                        <>
                                            <Button
                                                variant="primary"
                                                size="lg"
                                                type="submit"
                                                className="col-md-3 "
                                                disabled={isSubmitting}
                                            >
                                                Save
                                            </Button>

                                            <Button
                                                variant="danger"
                                                onClick={() =>
                                                    navigate(redirectPath)
                                                }
                                                className="m-3"
                                                disabled={isSubmitting}
                                            >
                                                Cancel
                                            </Button>
                                        </>
                                    }
                                    {isSubmitting && <div class="spinner-border" role="status">
                                        <span class="visually-hidden">Loading...</span>
                                    </div>}
                                </div>

                            </Form>
                        </>
                    )}
                </Formik>
                <SnackbarAlert notif={notif} setNotif={setNotif} />
            </>}


        </React.Fragment>
    )
}

export default AdhocTpmrTrainingDates;